import darkBusIcon from '../../../../assets/icons/bus-dark.svg';
import darkFerryIcon from '../../../../assets/icons/ferry-dark.svg';
import darkTaxiIcon from '../../../../assets/icons/taxi-dark.svg';
import darkTrainIcon from '../../../../assets/icons/train-dark.svg';
import darkTramIcon from '../../../../assets/icons/tram-dark.svg';
import darkWalkIcon from '../../../../assets/icons/walk-dark.svg';
import darkBikeIcon from '../../../../assets/icons/bike-dark.svg';
// NV-5212 - Buss on demand should be removed when trial period is over
import darkDynamicBusIcon from '../../../../assets/icons/buss-on-demand-dark.svg';
import { TransportMode } from '../../../models/transport-mode.enum';
import { TransportModeHelper } from '../../../helpers/transport-mode.helper';
import DataUrlHelper from '../../../helpers/data-url.helper';

function getTransportModeImageSource(transportMode: TransportMode): string {
  if (transportMode === TransportMode.train) {
    return DataUrlHelper.encode(darkTrainIcon);
  }
  if (transportMode === TransportMode.bus) {
    return DataUrlHelper.encode(darkBusIcon);
  }
  if (transportMode === TransportMode.tram) {
    return DataUrlHelper.encode(darkTramIcon);
  }
  if (transportMode === TransportMode.ferry) {
    return DataUrlHelper.encode(darkFerryIcon);
  }
  if (transportMode === TransportMode.taxi) {
    return DataUrlHelper.encode(darkTaxiIcon);
  }
  if (transportMode === TransportMode.walk) {
    return DataUrlHelper.encode(darkWalkIcon);
  }
  if (transportMode === TransportMode.bike) {
    return DataUrlHelper.encode(darkBikeIcon);
  }
  // NV-5212 - Buss on demand should be removed when trial period is over
  if (transportMode === TransportMode.bussondemand) {
    return DataUrlHelper.encode(darkDynamicBusIcon);
  }
  return '';
}

function TransportModeIcon({ transportMode, className, alt = undefined }: { transportMode: TransportMode; className?: string; alt?: string }) {
  return (
    <img
      className={`transport-mode-icon-component${className ? ` ${className}` : ''}`}
      src={getTransportModeImageSource(transportMode)}
      alt={alt !== undefined ? alt : TransportModeHelper.translate(transportMode)}
      title={alt !== undefined ? alt : TransportModeHelper.translate(transportMode)}
    />
  );
}

export default TransportModeIcon;
